export default __webpack_public_path__ + "static/media/05_card-2.19c62cf8.jpg";